const webSocketUUID = {
  state: {
    openAnAccountUUID: {}, //仪表开户
    rechargeUUID: {}, //仪表充值
    refundUUID: {}, //仪表退费
    controlAvailableUUID: {}, //仪表控制
    controlSwitchUUID: {}, //远程分合闸
  }
}
export default webSocketUUID